import React, { useState, useEffect } from 'react'
import { Grid, Paper, ButtonBase, Dialog, DialogTitle, DialogActions, Typography, Button, CardMedia, DialogContent } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { completeTask } from '../../../api/APIServices';
import { useDispatch } from 'react-redux';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import mp3Image from '../../../assets/images/video-player.png'

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
  borderRadius: '7px'
});

function Education({ education }) {
  const dispatch = useDispatch();

  const { t } = useTranslation('global');
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const markAsComplete = (taskId) => {
    dispatch(completeTask({ taskId: taskId }));
    setOpen(false);
  }



  return (
    <Paper
      sx={{
        p: 2,
        margin: '5px',
        width: '100%',
        maxWidth: 800,
        boxShadow: 0,
        backgroundColor: '#c7d6df'
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} display="flex" justifyContent="center">
          <ButtonBase onClick={handleClickOpen} sx={{ width: { xs: 100, sm: 128 }, height: { xs: 100, sm: 128 } }}>
            <Img alt="complex" src={mp3Image} sx={{ maxWidth: '100%', maxHeight: '100%' }} />
          </ButtonBase>
        </Grid>
        <Grid item xs={12} sm={8} container>
          <Grid item container direction="column" spacing={1}>
            <Grid item>
              <Grid container justifyContent="space-between" alignItems="center">
                <Typography gutterBottom variant="subtitle1" component="div">
                  {education.type}
                </Typography>
                {education?.isCompleted && (
                  <CheckCircleIcon sx={{ color: 'green' }} />
                )}
              </Grid>
              <Typography variant="body2" gutterBottom>
                {education.type}
              </Typography>
            </Grid>
            <Grid item>
              <Button
                size="small"
                type="button"
                variant="outlined"
                onClick={handleClickOpen}
              >
                Play
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: '100%',
              fontFamily: 'Open Sans',
              minHeight: '400px',
            }
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">{education.type}</DialogTitle>
        <DialogContent>
          <CardMedia
            component="video"
            image={education.audioUrl}
            controls
            sx={{ width: '100%', height: { xs: 200, sm: 300, md: 380 } }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            size="small"
            variant="contained"
            onClick={handleClose}
          >
            {t('close')}
          </Button>
          <Button
            color="primary"
            size="small"
            variant="outlined"
            onClick={() => markAsComplete(education.taskId)}
          >
            {t('mark_as_complete')}
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>

  )
}

export default Education